import api from "./api";
import { ENV } from "../utils/constants";

export const putPauseCampaign = async (id_campanha: number) => {
  return api.put(`insights-p2-${ENV}/${ENV}/crm/performance/pauseCampanha`, {
    campanha: id_campanha,
  });
};

export const putContinueCampaign = async (id_campanha: number) => {
  return api.put(`insights-p2-${ENV}/${ENV}/crm/performance/continueCampanha`, {
    campanha: id_campanha,
  });
};

export const resendCampaign = async (id_campanha: number) => {
  return api.post(
    `insights-p2-${ENV}/${ENV}/crm/insights/postReenviarCampanha`,
    {
      campanha: id_campanha,
    }
  );
};

export const sendingCampaigns = async (id_campanha: number) => {
  const response = await api.get(
    `insights-p2-${ENV}/${ENV}/crm/prospeccao/pessoasByIdCampanha`,
    { params: { id_campanha } }
  );

  return response.data.resposta;
};

export const pauseAdsCampaign = async (id_campanha: number) => {
  return api.delete(
    `https://api.datasales.info/ads-manager-${ENV}/ads/${id_campanha}`
  );
};

export const continueAdsCampaign = async (id_campanha: number) => {
  return api.put(
    `https://api.datasales.info/ads-manager-${ENV}/ads/${id_campanha}`,
    {
      status: "ACTIVE",
      access_token:
        "EAALk5H3jEBoBAFBz9ZC32pnS5Hbs5wVhS3thEbbwNkZAnNELlALWYYBGga2ZAFoAnNxwN4ZBQe9baPLbcfhWMA1F1tZAjpRLt5VaAF9EaBHh4LchR9KcMRYvxcNNF4BcjhbPaeUzHuzk6cHwWIQqy6p2MRDKpXPgPfx9an4VvMbdrdIfpVKro8QYfuoZCFdo0ZD",
    }
  );
};
